import React from 'react';

import { Nullable } from '@clearverify/types';

import { InboxItemInfoFragment, useInboxItemQuery } from 'src/api';
import { RESOURCES_INBOX_ITEM_ID } from 'src/constants/resources';
import { InboxItemExtended } from 'src/types/inbox';

import { useResourcesInboxItem } from '../resources/useResourcesInboxItem';

export const useInboxItemById = (id: Nullable<string>) => {
  const isResourcesInboxItem = id === RESOURCES_INBOX_ITEM_ID;

  const { data, loading } = useInboxItemQuery({
    variables: {
      id: String(id),
    },
    skip: !id || isResourcesInboxItem,
  });

  const {
    hasResourcesInboxItem,
    resourcesInboxItem,
    loading: resourcesInboxItemLoading,
  } = useResourcesInboxItem(!isResourcesInboxItem);

  const inboxItem = React.useMemo(() => {
    if (!data?.inboxItem) return null;
    return data.inboxItem as InboxItemExtended<InboxItemInfoFragment>;
  }, [data?.inboxItem]);

  if (isResourcesInboxItem && hasResourcesInboxItem) {
    return {
      inboxItem: resourcesInboxItem as InboxItemExtended<InboxItemInfoFragment>,
      loading: resourcesInboxItemLoading,
    };
  }

  return {
    inboxItem,
    loading,
  };
};
